<div class="fullscreen" *ngIf="loggedIn">
  <div
    style="position: fixed; left: 0; top: 0; z-index: 1000"
    *ngIf="isMobile && !sidenavIsOpen"
  ></div>
  <mat-sidenav-container fullscreen>
    <mat-sidenav
      mode="side"
      [opened]="sidenavIsOpen"
      [ngClass]="{ 'mobile-sidenav': isMobile }"
    >
      <div class="sidenav" [ngClass]="{ 'mobile-nav': isMobile }">
        <div
          *ngIf="isMobile"
          class="column-layout"
          style="justify-content: stretch; height: 100vh"
        >
          <div class="mobile-nav-button-wrapper" style="margin-bottom: 1rem">
            <button
              mat-icon-button
              class="mobile-nav-button"
              (click)="toggleSidenav(false)"
            >
              <mat-icon>arrow_back</mat-icon>
              Schließen
            </button>
          </div>

          <div *ngIf="isAdmin" style="flex: 1">
            <div
              class="mobile-nav-button-wrapper"
              [ngClass]="this.activePaths.ORDERS_ALL[0]"
            >
              <button
                mat-icon-button
                class="mobile-nav-button"
                [ngClass]="this.activePaths.ORDERS_ALL[1]"
                (click)="gotoPage(paths.ORDERS_ALL)"
              >
                <mat-icon>home</mat-icon> Start
              </button>
            </div>
            <!---->
            <div class="mobile-nav-separator">Auftragsverwaltung</div>
            <div
              class="mobile-nav-button-wrapper"
              [ngClass]="this.activePaths.ORDERS_OPEN[0]"
            >
              <button
                mat-button
                class="mobile-nav-button"
                [ngClass]="this.activePaths.ORDERS_OPEN[1]"
                (click)="gotoPage(paths.ORDERS_OPEN)"
              >
                offen
              </button>
            </div>
            <div
              class="mobile-nav-button-wrapper"
              [ngClass]="this.activePaths.ORDERS_ASSIGNED[0]"
            >
              <button
                mat-button
                class="mobile-nav-button"
                [ngClass]="this.activePaths.ORDERS_ASSIGNED[1]"
                (click)="gotoPage(paths.ORDERS_ASSIGNED)"
              >
                zugewiesen
              </button>
            </div>
            <div
              class="mobile-nav-button-wrapper"
              [ngClass]="this.activePaths.ORDERS_COMPLETE[0]"
            >
              <button
                mat-button
                class="mobile-nav-button"
                [ngClass]="this.activePaths.ORDERS_COMPLETE[1]"
                (click)="gotoPage(paths.ORDERS_COMPLETE)"
              >
                ausgeführt
              </button>
            </div>
            <div
              class="mobile-nav-button-wrapper"
              [ngClass]="this.activePaths.ORDERS_CANCELLED[0]"
            >
              <button
                mat-button
                class="mobile-nav-button"
                [ngClass]="this.activePaths.ORDERS_CANCELLED[1]"
                (click)="gotoPage(paths.ORDERS_CANCELLED)"
              >
                storniert
              </button>
            </div>
            <!--
            <div class="mobile-nav-button-wrapper"
            [ngClass]="dialogLinkCls">

              [ngClass]="this.activePaths.ORDERS_CANCELLED[1]"

              <button
                mat-button
                class="mobile-nav-button"
                (click)="showReceiptDialog()"
              >
                SB-Quittungen drucken
              </button>
            </div>
            -->
            <!---->
            <div class="mobile-nav-separator">Stammdaten</div>
            <div class="mobile-nav-button-wrapper">
              <button
                mat-button
                class="mobile-nav-button"
                (click)="gotoPage(['/customers'])"
              >
                Kunden
              </button>
            </div>
            <div class="mobile-nav-button-wrapper">
              <button
                mat-button
                class="mobile-nav-button"
                (click)="gotoPage(['/partners'])"
              >
                Partner
              </button>
            </div>

            <div class="mobile-nav-button-wrapper">
              <button
                mat-button
                class="mobile-nav-button"
                (click)="gotoPage(['/teams'])"
              >
                Montageteams
              </button>
            </div>
          </div>
          <div class="mobile-nav-button-wrapper" style="margin-top: 1rem">
            <button
              mat-icon-button
              class="mobile-nav-button"
              (click)="logout()"
            >
              <mat-icon>power_settings_new</mat-icon>
              <span style="font-weight: 800">Ausloggen</span>
            </button>
          </div>
        </div>
        <ng-container *ngIf="!isMobile && isAdmin">
          <div>
            <div class="content-header in-sidenav"></div>
            <a
              class="navlink"
              [routerLink]="paths.ORDERS_ALL"
              routerLinkActive="router-link-active"
            >
              Startseite
            </a>
            <br />
            <br />
            <div>Auftragsverwaltung</div>
            <ul>
              <ng-container *ngFor="let pd of adminPaths">
                <li>
                  <a
                    class="navlink"
                    [routerLink]="pd.path"
                    routerLinkActive="router-link-active"
                  >
                    {{ pd.title }}
                  </a>
                </li>
              </ng-container>
              <br />
              <li>
                <a
                  class="navlink"
                  style="text-decoration: underline"
                  (click)="showReceiptDialog($event)"
                  href="/#"
                >
                  SB Quittungen drucken
                </a>
              </li>
            </ul>
          </div>
          <br />
          <div>
            <div>Stammdaten</div>
            <ul style="margin-top: 10px">
              <li>
                Kunden
                <ul style="margin-top: 10px">
                  <li>
                    <a
                      class="navlink"
                      [routerLink]="['/customers']"
                      routerLinkActive="router-link-active"
                    >
                      Bestand
                    </a>
                  </li>
                  <li>
                    <a
                      class="navlink"
                      [routerLink]="['/customers/0']"
                      routerLinkActive="router-link-active"
                    >
                      Neuer Kunde
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <a
                  class="navlink"
                  [routerLink]="['/partners']"
                  routerLinkActive="router-link-active"
                >
                  Partner
                </a>
              </li>
              <li>
                <a
                  class="navlink"
                  [routerLink]="['/teams']"
                  routerLinkActive="router-link-active"
                >
                  Montageteams
                </a>
              </li>
            </ul>
          </div>
          <br />
          <div>
            <div>Planer</div>
            <ul>
              <li *ngFor="let planer of planers" style="margin-bottom: 0.75rem">
                <a class="navlink" [routerLink]="['/date', planer.id]">
                  {{ planer.name }}
                </a>
              </li>
            </ul>
          </div>
          <br />
          <div>
            <div>Papierkorb</div>
            <ul>
              <li>
                <a
                  class="navlink"
                  [routerLink]="['/trash/orders']"
                  routerLinkActive="router-link-active"
                >
                  Aufträge
                </a>
              </li>
              <li>
                <a
                  class="navlink"
                  [routerLink]="['/trash/documents']"
                  routerLinkActive="router-link-active"
                >
                  Dokumente
                </a>
              </li>
              <!--
              <li *ngFor="let planer of planers" style="margin-bottom: 0.75rem">
                <a class="navlink" [routerLink]="['/date', planer.id]">
                  {{ planer.name }}
                </a>
              </li>
            --></ul>
          </div>
        </ng-container>
        <ng-container *ngIf="!isAdmin">
          <div class="content-header in-sidenav"></div>
          <a class="navlink for-montage" [routerLink]="['/date', user_id]"> Planner </a>
          <br />
          <div class="nav-orders-montage">Auftragsverwaltung</div>
          <ul>
            <li *ngFor="let pd of montagePaths">
              <a
                class="navlink for-montage"
                [routerLink]="pd.path"
                routerLinkActive="router-link-active"
              >
                {{ pd.title }}
              </a>
            </li>
          </ul>
        </ng-container>
      </div>
      <!--sidenav end-->
    </mat-sidenav>
    <mat-sidenav-content class="content">
      <div
        style="
          height: 100vh;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
        "
      >
        <div class="content-header">
          <div *ngIf="isMobile && !sidenavIsOpen">
            <button
              mat-icon-button
              (click)="toggleSidenav(true)"
              style="color: white"
            >
              <mat-icon>menu</mat-icon>
            </button>
          </div>
          <div style="padding-left: 8px">
            {{ title }}
          </div>
          <div class="top-toolbar-buttons">
            <button
              mat-button
              class="top-toolbar-button"
              style="margin-right: 1.5rem"
              type="button"
              (click)="showSettings()"
            >
              <mat-icon class="top-toolbar-button-icon">settings</mat-icon>
              <span class="top-toolbar-button-text">Einstellungen</span>
            </button>

            <button
              *ngIf="!isMobile"
              mat-button
              class="top-toolbar-button"
              type="button"
              (click)="logout()"
            >
              <mat-icon class="top-toolbar-button-icon"
                >power_settings_new</mat-icon
              >
              <span class="top-toolbar-button-text">Ausloggen</span>
            </button>
          </div>
        </div>
        <img src="/img/montage/header2.png" style="height: auto; width: 100%" />
        <div class="router-outlet-container">
          <router-outlet></router-outlet>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
<div class="fullscreen" *ngIf="loggedIn === false">
  <div class="login-div">
    <!-- -->
    <div class="login-div2">
      <div class="login-container-before"></div>
      <!-- -->
      <div class="login-container">
        <div class="login-logo">
          <img src="/img/montage/vectorpaint.svg" class="login-logo-img" />
        </div>
        <div style="padding: 0.5rem 1rem 1rem 1rem">
          <div style="margin-bottom: 2rem" *ngIf="hasGhost">
            <label for="ghost" class="login-label">Ghost</label>
            <input id="ghost" name="ghost" [(ngModel)]="ghost" class="login-input" />
          </div>

          <div style="margin-bottom: 1rem">
            <label for="username" class="login-label">Benutzername</label>
            <input id="username" name="username" [(ngModel)]="username" class="login-input" />
          </div>
          <div style="margin-bottom: 1rem">
            <label for="password" class="login-label">Passwort</label>
            <input
              id="password"
              name="password"
              type="password"
              [(ngModel)]="password"
              class="login-input"
            />
          </div>
          <div style="margin: auto">
            <button class="login-button" type="button" (click)="login()">
              Anmelden
            </button>
            <div *ngIf="errorMessage" class="error-message">
              {{ errorMessage }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- -->
    <div class="login-company-info bg-transparent" style="font-weight: 600">
      <div class="company-block-wrapper">
        <div class="company-block">
          <div class="company-name">MAG UG (haftungsbeschränkt)</div>
          <div class="company-address">Merkurstr. 13</div>
          <div class="company-city">67663 Kaisersalutern</div>
        </div>
      </div>

      <!-- -->
      <div class="login-company-info-contact contact-header">Kontakt</div>
      <div class="phone-line">
        Fon: <a href="tel:+4963153444388">0631/53444388</a>
      </div>
      <div class="fax-line">Fax: 0631/75000730</div>
      <!-- -->
      <div class="login-company-info-net-contact email-line">
        E-Mail: info&#64;mobileautoglas.de
      </div>
      <div class="site-line">Internet: www.mobileautoglas.de</div>
    </div>
  </div>
  <!---->
  <div class="login-bottom-area">
    <div class="copyright">
      Copyright 2022-2024 &#169; MAG UG. All rights reserved.
    </div>
    <div class="login-bottom-block">
      <div class="imprint-link">
        <a href="https://montage.mobileautoglas.de/imprint/">Impressum</a>
      </div>
      <div class="data-protection-link">
        <a href="https://montage.mobileautoglas.de/disclaimer/">Datenschutz</a>
      </div>
    </div>
  </div>
</div>
